import { useState } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useSeason = () => {

    const [seasons, setSeasons] = useState(null);
    const [currentSeason, setCurrentSeason] = useState(null);
    const [seasonRewards, setSeasonRewards] = useState(null);

    const fetchSeasons = async () => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/seasons`, 'GET');

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to fetch seasons');
            }

            const seasons = await response.json();
            setSeasons(seasons.reverse());
        } catch (err) {
            console.error("Error fetching seasons");
        }
    }

    // Fetch the current season
    const fetchCurrentSeason = async () => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/seasons/current`, 'GET');

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to fetch current season');
            }

            setCurrentSeason(await response.json());
        } catch (err) {
            console.error("Error fetching current season");
        }
    };

    // Fetch season rewards by season ID
    const fetchSeasonRewards = async (seasonId) => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/seasons/${seasonId}/rewards`, 'GET');

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to fetch season rewards');
            }

            const rewards = await response.json();
            setSeasonRewards(rewards);
        } catch (err) {
            console.error("Error fetching season rewards");
            setSeasonRewards(null);
        }
    };

    return { seasons, fetchSeasons, currentSeason, fetchCurrentSeason, seasonRewards, fetchSeasonRewards };
};

export default useSeason;